import {
  initialPublishingState,
  updateAttractions,
} from './publishing/publishingInitialState';
import publishingProductReducer from './publishing/publishingProductReducer';
import publishingListedReducer from './publishing/publishingListedReducer';
import publishingMediaReducer from './publishing/publishingMediaReducer';
import publishingAttractionsReducer from './publishing/publishingAttractionsReducer';

export { updateAttractions };

export default function publishing(
  state = initialPublishingState,
  action = {}
) {
  let nextState = publishingProductReducer(state, action);
  if (nextState !== state) return nextState;

  nextState = publishingListedReducer(state, action);
  if (nextState !== state) return nextState;

  nextState = publishingMediaReducer(state, action);
  if (nextState !== state) return nextState;

  nextState = publishingAttractionsReducer(state, action);
  if (nextState !== state) return nextState;

  return state;
}
